import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  closeButton: {
    width: '84px',
    alignSelf: 'flex-end',
    marginTop: 20,
  }
});

const PanelAction = (props) => {
  const { handleClose, classes } = props;
  return (
    <Button
      autoFocus
      onClick={handleClose}
      color="primary"
      variant="outlined"
      className={classes.closeButton}>
      Close
    </Button>
  );
};

export default withStyles(styles)(PanelAction);
